import React, { useMemo } from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import type { IExpenseStatusTagProps } from './types';

export const ExpenseStatusTag: React.FC<IExpenseStatusTagProps> = (props) => {
  const { status } = props;

  const getTagProps = (): { color: string; icon: React.ReactNode } | object => {
    switch (status) {
      case 'waiting':
        return { color: '', icon: <ClockCircleOutlined /> };
      case 'completed':
        return { color: 'green', icon: <CheckCircleOutlined /> };
      case 'problem':
        return { color: 'orange', icon: <ExclamationCircleOutlined /> };
      case 'cancelled':
        return { color: '', icon: <CloseCircleOutlined /> };
      default:
        return {};
    }
  };

  const tagProps = useMemo(getTagProps, [status]);

  if (!status) return null;

  return <Tag {...tagProps}>{status}</Tag>;
};
